import React, { useEffect, useState } from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useDispatch } from "react-redux";
import FacebookIcon from "./Facebook_f_logo_(2021).svg.png";
const REACT_APP_FACEBOOK_CLIENT_ID = process.env.REACT_APP_FACEBOOK_CLIENT_ID;

const FacebookAuth = () => {
  const dispatch = useDispatch();
  const [facebookUser, setFacebookUser] = useState(null);
  const [social_user, setSocialUser] = useState(null);

  useEffect(() => {
    if (social_user !== null) {
      dispatch({ type: "GET_SOCIAL_USER", payload: social_user });
    }
  }, [social_user]);
  useEffect(() => {
    if (facebookUser) {
      const user = {
        first_name: facebookUser?.name,
        email: facebookUser?.email,
        avatar: facebookUser?.picture?.data.url,
      };
      setSocialUser(user);
    }
  }, [facebookUser]);
  const responseFacebook = (res) => {
    setFacebookUser(res);
  };
  return (
    <div
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "4px",
        background: "white",
        marginLeft: "12px",
        border: "1px #dadce0 solid",
      }}
    >
      <FacebookLogin
        appId={REACT_APP_FACEBOOK_CLIENT_ID}
        autoLoad={false}
        fields="name,email,picture"
        onFailure={(err) => {
          console.log("errerrerr", err);
        }}
        callback={responseFacebook}
        render={(props) => (
          <div
            onClick={() => {
              props.disabled ? "" : props.onClick();
            }}
            style={{
              cursor: props.disabled ? "none" : "pointer",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              style={{ height: "50%", width: "50%", objectFit: "cover" }}
              src={FacebookIcon}
            />
          </div>
        )}
      />
    </div>
  );
};

export default FacebookAuth;
